import React from 'react';
import Immutable from 'immutable';

import * as BetStatus from 'constants/BetStatus';
import {addClass, removeClass} from 'rendering-commons';

import * as MatchScoresAdapter from 'shared/adapters/MatchScoresAdapter';

export class BaseRate extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        user: React.PropTypes.object,
        rate: React.PropTypes.object,
        match: React.PropTypes.object,
        outcome: React.PropTypes.object,
        score: React.PropTypes.object,
        isInCoupon: React.PropTypes.bool.isRequired,
        outcomeIsBlocked: React.PropTypes.bool.isRequired,
        addCouponRateAction: React.PropTypes.func.isRequired,
        makeBetAction: React.PropTypes.func.isRequired,
        requestBetTypesAction: React.PropTypes.func.isRequired,
        addRateAction: React.PropTypes.func.isRequired,
        gridLocalization: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this._timeoutId = null;

        this._onClick = this._onClick.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        return this.props.rate !== nextProps.rate ||
            this.props.outcomeIsBlocked !== nextProps.outcomeIsBlocked ||
            this.props.isInCoupon !== nextProps.isInCoupon ||
            this.props.user !== nextProps.user ||
            this.props.gridLocalization.languageId !== nextProps.gridLocalization.languageId;
    }

    componentDidUpdate(prevProps) {
        const rate = this.props.rate;

        if (rate === undefined || rate.get('isBlocked') || !rate.get('isVisible')) {
            return;
        }

        const element = this.refs.rate;

        if (!element) {
            return;
        }

        const currentValue = rate.get('value');
        const prevValue = prevProps.rate.get('value');

        let className = null;

        if (currentValue > prevValue) {
            className = 'changed-outcome-up';
        } else if (currentValue < prevValue) {
            className = 'changed-outcome-down';
        }

        if (className === null) {
            return;
        }

        addClass(element, className);

        this._timeoutId = window.setTimeout(this._onTimeout.bind(this, element, className), 2000);
    }

    componentWillUnmount() {
        if (this._timeoutId !== null) {
            window.clearTimeout(this._timeoutId);
        }
    }

    _onTimeout(element, className) {
        removeClass(element, className);
        this._timeoutId = null;
    }

    static activeBetExists(betHistory) {
        const bet = betHistory.valueSeq().find(b => b.get('betStatus') < BetStatus.ACCEPTED);

        return bet !== undefined;
    }

    _onClick(e) {
        e.preventDefault();

        const {rate, match, outcome, betHistory, isInCoupon} = this.props;

        /*if (!user) {
         //TODO: dispatch action 'require log in'
         return;
         }*/

        if (isInCoupon) {
            return;
        }

        if (rate.get('isBlocked') || !rate.get('isVisible')) {
            return;
        }

        if (BaseRate.activeBetExists(betHistory)) {
            return;
        }

        const score = this.getMatchScore(match);

        this.props.addRateAction({rate, match, outcome, score});
    }

    getMatchScore(match) {
        if (match === undefined) {
            return undefined;
        }

        const mainScoreId = MatchScoresAdapter.getMainScore(match.get('scores'));

        if (mainScoreId !== null) {
            return this.props.scores.get(mainScoreId);
        }

        return undefined;
    }
}

export function mapStateToProps(state, props) {
    const {section, id, gridLocalization} = props;

    const sectionObject = state.application.get(section);
    const coupon = state.application.get('coupon');

    const rate = sectionObject.get('rates').get(id);
    const isInCoupon = coupon ? coupon.get('betSlips').has(id) : false;
    const scores = sectionObject.get('scores');
    const bettingMode = state.application.get('bettingMode');
    const betHistory = state.application.get('betHistory');
    const user = state.auth.get('user');

    let match;
    let outcome;
    let rateWithName = rate;
    let outcomeIsBlocked = false;

    if (rate) {
        match = sectionObject.get('matches').get(rate.get('matchId'));
        outcome = sectionObject.get('outcomes').get(rate.get('outcomeId'));
        outcomeIsBlocked = outcome.get('isBlocked');

        rateWithName = rate;

        if (match) {
            const sportId = match.get('realSportId');
            const matchObj = {
                homeTeam: match.get('firstTeam'),
                awayTeam: match.get('secondTeam')
            };

            const outcomeObj = outcome.toJS();
            outcomeObj.name = gridLocalization.getOutcomeName(sportId, outcomeObj, matchObj);
            outcome = Immutable.fromJS(outcomeObj);

            const rateObj = rate.toJS();
            rateObj.shortName = gridLocalization.getRateName(sportId, outcomeObj, rate.get('type'), matchObj);
            rateWithName = Immutable.fromJS(rateObj);
        }
    }

    return {
        rate: rateWithName,
        match,
        outcome,
        scores,
        isInCoupon,
        outcomeIsBlocked,
        bettingMode,
        betHistory,
        user
    };
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/rates/BaseRate.jsx